import React from "react";
import { useStore } from "../../store/store";
import fractionToInt from "../../util/fractionToInt";

interface UpdateObj {
  dropseal?: string;
  hingeColor?: string;
}

const useDropsealSelector = () => {
  const addToQuote = useStore((state) => state.addToQuote);
  const dropseal = useStore((state) => state.quote.dropseal);
  const pivotHardware = useStore((state) => state.quote.pivotHardware);

  const swingPanelWidth = useStore((state) => state.quote.swingPanelWidth);
  const swingPanelFraction = useStore(
    (state) => state.quote.swingPanelFraction
  );

  const panelWidth = fractionToInt(swingPanelWidth || "", swingPanelFraction);

  const handleClick = (label: string) => {
    const checked = label === dropseal;

    if (checked) {
      addToQuote({ dropseal: "" }, "dropseal");
    } else {
      let update: UpdateObj = { dropseal: label };
      if (pivotHardware === "Fritsjurgens") {
        update["hingeColor"] = "Stainless Steel";
      }
      addToQuote(update);
    }
  };

  return {
    handleClick,
    panelWidth,
    dropseal,
  };
};

export default useDropsealSelector;
